import { FirstReportMonitoredModal } from "@/monitoring/FirstReportMonitoredModal/FirstReportMonitoredModal";
import type { SxProps } from "@/theme/index";
import type { ValidReportTypes } from "@/utils/helperTypes";
import { ReportActionButton } from "../ReportActionButton/ReportActionButton";
import { useMonitorAction } from "./useMonitorAction";

type MonitorActionProps = {
  reportType: ValidReportTypes | string;
  sx?: SxProps;
  reportPermaLink?: string;
  onReportCard?: boolean;
  disableCollapse?: boolean;
};

export const MonitorAction: React.FC<MonitorActionProps> = ({
  reportType,
  sx,
  reportPermaLink,
  onReportCard,
  disableCollapse,
}) => {
  const {
    handleMonitorToggle,
    showMonitoringModal,
    setShowMonitoringModal,
    reportIsMonitored,
    reportMonitorIsLoading,
  } = useMonitorAction({ reportType, reportPermaLink });
  const active = reportIsMonitored;

  const handleMonitorClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    handleMonitorToggle();
  };
  return (
    <>
      <ReportActionButton
        iconName={active ? "Notifications" : "NotificationsNone"}
        collapseText={active ? "Monitored" : "Monitor"}
        onClick={handleMonitorClick}
        active={active}
        disabled={reportMonitorIsLoading}
        sx={sx}
        onReportCard={onReportCard}
        disableCollapse={disableCollapse}
        isLoading={reportMonitorIsLoading}
      />
      <FirstReportMonitoredModal
        isOpen={showMonitoringModal}
        closeModal={() => setShowMonitoringModal(false)}
      />
    </>
  );
};
